import { $sheet } from '@/components/SheetView';
import { $highlight } from '@/components/selection';
import { type CellStyle, DEFAULT_CELL_STYLE } from '@/model/cellStyle';
import type { RichTextStyle } from '@/model/richText';
import { type BaseStyle, computeStyle } from '@/model/types';
import { atom, computed } from 'nanostores';

export const $selectedRichTextStyle = atom<BaseStyle<RichTextStyle>>({});
export const $selectedCellStyle = atom<BaseStyle<CellStyle>>({});
export const $selectedComputedStyle = computed(
  [$selectedRichTextStyle, $selectedCellStyle],
  (richTextStyle, cellStyle) => {
    return computeStyle(DEFAULT_CELL_STYLE, cellStyle, richTextStyle);
  },
);

export function init() {
  let prev: () => void = () => {};
  $highlight.subscribe(pos => {
    const sheet = $sheet.get();
    if (!sheet) return;
    prev();
    const store = sheet.cellStore(pos);
    prev = store.subscribe(cell => {
      if (!cell) return;
      $selectedCellStyle.set(cell.style);
    });
  });
}
